import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSearch, FiBell, FiActivity } = FiIcons;

export default function TopBar({ title }) {
  return (
    <header className="h-16 border-b border-[#004B87]/20 bg-[#FFFFF0]/90 backdrop-blur-md sticky top-0 z-10 flex items-center justify-between px-8">
      <div className="flex items-center gap-4">
        <h2 className="text-xl font-bold uppercase tracking-widest text-[#004B87]">{title}</h2>
        <div className="h-4 w-px bg-[#004B87]/30"></div>
        <div className="flex items-center gap-2 text-[10px] font-mono text-[#004B87]/60">
          <SafeIcon icon={FiActivity} className="text-[#C1440E] animate-pulse" />
          SYSTEM_STABLE
        </div>
      </div>
      
      <div className="flex items-center gap-6">
        <div className="relative group hidden lg:block">
          <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#004B87]/40 group-focus-within:text-[#C1440E] transition-colors" />
          <input 
            type="text" 
            placeholder="Search asset, lease, or ticket..." 
            className="pl-9 pr-4 py-1.5 bg-[#004B87]/5 border border-[#004B87]/20 text-xs focus:outline-none focus:border-[#C1440E] focus:bg-white transition-all placeholder:text-[#004B87]/30 font-mono w-64" 
          />
        </div>
        <button className="relative text-[#004B87]/60 hover:text-[#C1440E] transition-all">
          <SafeIcon icon={FiBell} className="text-xl" />
          <span className="absolute -top-1 -right-1 w-2 h-2 bg-[#C1440E] rounded-full border-2 border-[#FFFFF0]"></span>
        </button>
      </div>
    </header>
  );
}